import { ReactElement, useCallback } from 'react';
import { useConfirm } from 'react-router-prompt';

import ConfirmModal from '~/ui/components/common/ConfirmModal';

interface IProps {
  when: boolean;
  description: string;
  beforeConfirm?: () => void;
}

const NavigationConfirmModal = ({
  when = true,
  description = 'Are you sure you want to leave this page?',
  beforeConfirm,
}: IProps): ReactElement => {
  const { isActive, onConfirm, resetConfirmation } = useConfirm(when);

  const handleConfirm = useCallback(async () => {
    if (beforeConfirm) {
      await new Promise<void>(resolve => setTimeout(resolve, 0));
      beforeConfirm();
    }
    onConfirm();
  }, [beforeConfirm, onConfirm]);

  return (
    <ConfirmModal
      open={isActive}
      description={description}
      onClose={resetConfirmation}
      onConfirm={handleConfirm}
    />
  );
};

export default NavigationConfirmModal;
